import { render, staticRenderFns } from "./ChatHistory.vue?vue&type=template&id=07e8f995&scoped=true&"
import script from "./ChatHistory.vue?vue&type=script&lang=js&"
export * from "./ChatHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChatHistory.vue?vue&type=style&index=0&id=07e8f995&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e8f995",
  null
  
)

export default component.exports